export default __webpack_public_path__ + "static/media/YounesBenbouchta.b2f23d77.webp";